import { render, staticRenderFns } from "./Sso.vue?vue&type=template&id=1ffce6ee&"
import script from "./Sso.vue?vue&type=script&lang=ts&"
export * from "./Sso.vue?vue&type=script&lang=ts&"
import style0 from "./Sso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports